import { render, staticRenderFns } from "./notify.vue?vue&type=template&id=375052dc&scoped=true"
import script from "./notify.vue?vue&type=script&lang=js"
export * from "./notify.vue?vue&type=script&lang=js"
import style0 from "./notify.vue?vue&type=style&index=0&id=375052dc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "375052dc",
  null
  
)

export default component.exports